export const getStyleParams = state => state.styleParams || {};
